module.exports = __webpack_public_path__ + "img/partner-title-light.2d0ca12.png";